<template>
  <div class="detail-container">
    <div class="detail-card">
      <!-- 标题区 -->
      <div class="detail-header">
        <h1 class="title">{{ gameData.title }}</h1>
        <div class="meta-info">
          <el-tag
            :type="gameData.download_type == 'free' ? 'success' : 'danger'"
            class="price-tag"
          >
            {{ gameData.download_type == "free" ? "免费" : "VIP" }}
          </el-tag>
          <span class="release-date">{{ getTheTime(gameData.updated_at) }}</span>
        </div>
      </div>

      <!-- 内容区 -->
      <div class="detail-content">
        <el-image :src="gameData.cover" fit="cover" class="main-image" />
        <div class="description" v-html="gameData.content"></div>

        <!-- 内容图片展示区 -->
        <div
          class="content-images"
          v-if="gameData.contentImages && gameData.contentImages.length"
        >
          <div
            v-for="(image, index) in gameData.contentImages"
            :key="index"
            class="content-image-wrapper"
          >
            <el-image
              :src="proxyImage(image)"
              fit="cover"
              class="content-image"
              :preview-src-list="gameData.contentImages.map((img) => proxyImage(img))"
            >
            </el-image>
          </div>
        </div>
      </div>

      <!-- 下载区域 -->
      <div class="download-section">
        <div class="download-card">
          <div class="download-info">
            <div class="download-title">获取游戏</div>
            <div class="download-desc">
              {{ gameData.download_type === "free" ? "免费下载" : "VIP专享" }}
            </div>
          </div>
          <el-button
            type="primary"
            class="download-btn"
            :class="{ 'vip-btn': gameData.download_type !== 'free' }"
            @click="handleDownload"
          >
            <i class="el-icon-download"></i>
            {{ gameData.download_type === "free" ? "立即下载" : "会员下载" }}
          </el-button>
        </div>
      </div>
      <!-- 网站声明 -->
      <div class="site-disclaimer">
        <h3>网站声明</h3>
        <p>
          本站发布的游戏资源如有侵犯你的合法权益请联系管理员下架 2HVR网站
          ，站内资源为网友个人行为上传学习或测试研究使用，未经原版权作者许可，禁止用于任何商业途径！
        </p>
        <p>
          本站资源来自网络，版权争议与本站无关。您必须在下载后的24个小时之内，从您的电脑或其他设备中彻底删除上述内容，用户所表达的"不代表本站立场"，所造成的后果与本站无关！
        </p>
        <p>
          本站为非盈利性站点，VIP功能仅仅作为用户喜欢本站捐赠打赏功能和人工技术解答服务，所有内容不作为商业行为。如果侵权请联系：2hvr@2hvr.me
          我们下架。
        </p>
      </div>
    </div>

    <el-dialog
      :visible.sync="showDownloadDialog"
      title="下载选项"
      width="700px"
      class="download-dialog"
      custom-class="custom-dialog"
    >
      <div v-if="isDownload" class="dialog-content">
        <!-- 下载使用情况卡片 -->
        <div class="download-stats-compact">
          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="el-icon-download"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value" :class="{ 'unlimited': downloadInfo.remainingDownloads === '无限次' }">
                  {{ downloadInfo.remainingDownloads }}
                </div>
                <div class="stat-label">剩余次数</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">
                <i class="el-icon-data-analysis"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ downloadInfo.totalDownloads }}</div>
                <div class="stat-label">已下载</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">
                <i class="el-icon-setting"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value" :class="{ 'unlimited': downloadInfo.totalLimit === '无限次' }">
                  {{ downloadInfo.totalLimit }}
                </div>
                <div class="stat-label">总限制</div>
              </div>
            </div>
          </div>
          <!-- 进度条 -->
          <div class="progress-section" v-if="downloadInfo.totalLimit !== '无限次' && downloadInfo.totalLimit > 0">
            <div class="progress-info">
              <span>下载进度</span>
              <span class="progress-text">{{ downloadInfo.totalDownloads }}/{{ downloadInfo.totalLimit }}</span>
            </div>
            <el-progress 
              :percentage="getDownloadProgress()" 
              :color="getProgressColor()"
              :stroke-width="6"
              class="download-progress"
            />
          </div>
        </div>

        <!-- 下载提示 -->
        <div class="download-tips-compact">
          <i class="el-icon-info"></i>
          <span>推荐使用千兆网络下载，预计下载时间3-5分钟</span>
        </div>

        <!-- 下载选项网格 -->
        <div class="download-options-grid">
          <el-button
            v-for="(option, index) in downloadOptions"
            :key="index"
            type="primary"
            class="download-option-compact"
            @click="openUrl(option.linkUrl)"
          >
            <i class="el-icon-download"></i>
            <span class="option-text">{{ option.linkName }}</span>
            <span class="option-badge">推荐</span>
          </el-button>
        </div>
        
        <!-- 密码提示区域 -->
        <div class="password-tips-compact">
          <div class="password-header">
            <i class="el-icon-key"></i>
            <span>密码提示</span>
          </div>
          <div class="password-grid">
            <div class="password-item-compact">
              <span class="password-label">解压密码</span>
              <div class="password-value-wrapper">
                <span class="password-value">vrmoo.cn</span>
                <el-button 
                  type="text" 
                  size="mini" 
                  @click="copyToClipboard('vrmoo.cn')"
                  class="copy-btn-compact"
                >
                  <i class="el-icon-document-copy"></i>
                </el-button>
              </div>
            </div>
            <div class="password-item-compact">
              <span class="password-label">资源密码</span>
              <div class="password-value-wrapper">
                <span class="password-value">vrmoo / vrmo</span>
                <el-button 
                  type="text" 
                  size="mini" 
                  @click="copyToClipboard('vrmoo')"
                  class="copy-btn-compact"
                >
                  <i class="el-icon-document-copy"></i>
                </el-button>
              </div>
            </div>
          </div>
          <div class="password-note-compact">
            <i class="el-icon-warning-outline"></i>
            <span>如资源遇到解压密码或提取密码问题，请使用上述密码</span>
          </div>
        </div>
      </div>

      <div v-else class="no-permission dialog-content">
        <div class="vip-reminder">
          <i class="el-icon-warning-outline warning-icon"></i>
          <div class="reminder-text">
            <h3>{{ getPermissionTitle() }}</h3>
            <p>{{ getPermissionMessage() }}</p>
          </div>
        </div>
        <div class="download-options">
          <el-button type="danger" class="upgrade-btn" @click="handleUpgrade">
            <i class="el-icon-shopping-cart-full"></i>
            {{ getUpgradeButtonText() }}
          </el-button>
          <el-button v-if="isBasic()" type="success" class="parse-btn" @click="handleClickGoMq">
            <i class="el-icon-s-promotion"></i>
            去魔趣解析
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, getInfoDownLoad } from "@/api";
import { formatTimeAgo } from "@/utils";
export default {
  data() {
    return {
      id: null,
      gameData: {
        title: "",
        download_type: "",
        created_at: "",
        cover: "",
        content: "",
        contentImages: [],
      },
      showDownloadDialog: false,
      isDownload: false,
      downloadOptions: [],
      downloadInfo: {
        remainingDownloads: "无限次",
        totalDownloads: 0,
        totalLimit: "无限次"
      },
      permissionAlert: {
        title: "今日下载次数已达上限/本月VIP已过期",
        type: "warning",
      },
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.fetchGameData();
  },
  methods: {
    handleClickGoMq(){
      this.$router.push({path: '/GetMqGame'}); 
    },
    isBasic(){
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      console.log(user);
      if (user.vipType === 'basic') {
        return true;
      }
      return false;
    },
    handleDownload() {
      getInfoDownLoad(this.id)
        .then((res) => {
          console.log(res);
          this.downloadOptions = res.data.links;
          // 处理新的下载次数信息字段
          if (res.data.remainingDownloads !== undefined) {
            this.downloadInfo.remainingDownloads = res.data.remainingDownloads;
          }
          if (res.data.totalDownloads !== undefined) {
            this.downloadInfo.totalDownloads = res.data.totalDownloads;
          }
          if (res.data.totalLimit !== undefined) {
            this.downloadInfo.totalLimit = res.data.totalLimit;
          }
          this.showDownloadDialog = true;
          this.isDownload = true;
        })
        .catch((err) => {
          console.log(err);
          this.isDownload = false;
          this.showDownloadDialog = true;
        });
    },
    fetchGameData() {
      getInfo(this.id)
        .then((res) => {
          this.gameData = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleUpgrade() {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      if (user.vipLevel === 0 || user.vipLevel === null) {
        this.$emit("showVipDialog",'all');
        return;
      }
      if (user.vipLevel > 0 && user.vipLevel != 9) {
        this.$emit("showVipDialog",'all');
        return;
      }
      if (user.vipType === 'basic') {
        this.$emit("showVipDialog",'升级');
        return;
      }
      
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    proxyImage(url) {
      // 方案1：使用后端代理
      // return `/api/proxy-image?url=${encodeURIComponent(url)}`;
      return url;
    },
    getTheTime(time){
      return formatTimeAgo(time);
    },
    getPermissionTitle() {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      // 普通用户
      if (!user.vipLevel || user.vipLevel == 0) {
        return '今日下载次数已达上限';
      }
      
      // 魔趣解析会员
      if (user.vipType === 'basic') {
        return '权限不足';
      }
      
      // 其他情况（全能会员过期等）
      return '本月VIP已过期';
    },
    
    getPermissionMessage() {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      // 普通用户
      if (!user.vipLevel || user.vipLevel == 0) {
        return '开通VIP畅享无限下载特权';
      }
      
      // 魔趣解析会员
      if (user.vipType === 'basic') {
        return '当前您的账号是魔趣解析会员，非全能会员，如需下载此资源请升级为全能会员';
      }
      
      // 其他情况（全能会员过期等）
      return '您的全能会员已过期/次数超限制，请续费后继续使用';
    },
    
    getUpgradeButtonText() {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      // 普通用户
      if (!user.vipLevel || user.vipLevel == 0) {
        return '立即开通VIP';
      }
      
      // 魔趣解析会员
      if (user.vipType === 'basic') {
        return '升级全能会员';
      }
      
      // 其他情况（全能会员过期等）
      return '立即续费';
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(`已复制：${text}`);
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text);
        });
      } else {
        this.fallbackCopyTextToClipboard(text);
      }
    },
    
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.$message.success(`已复制：${text}`);
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      
      document.body.removeChild(textArea);
    },
    
    // 计算下载进度百分比
    getDownloadProgress() {
      if (this.downloadInfo.totalLimit === '无限次' || this.downloadInfo.totalLimit <= 0) {
        return 0;
      }
      const progress = (this.downloadInfo.totalDownloads / this.downloadInfo.totalLimit) * 100;
      return Math.min(progress, 100);
    },
    
    // 获取进度条颜色
    getProgressColor() {
      const progress = this.getDownloadProgress();
      if (progress < 50) {
        return '#67c23a'; // 绿色
      } else if (progress < 80) {
        return '#e6a23c'; // 橙色
      } else {
        return '#f56c6c'; // 红色
      }
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 40px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.detail-card {
  background: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.detail-header {
  margin-bottom: 30px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 20px;
}

.title {
  color: #2c3e50;
  font-size: 24px;
  margin-bottom: 15px;
}

.meta-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.main-image {
  width: 100%;
  height: 400px;
  border-radius: 8px;
  margin-bottom: 25px;
}

.description {
  color: #606266;
  line-height: 1.8;
  margin-bottom: 30px;
  white-space: pre-wrap; /* 添加这行，保留换行和空格 */
}

.content-images {
  margin: 30px 0;
}

.content-image-wrapper {
  margin-bottom: 20px;
}

.content-image {
  width: 100%;
  height: 400px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.content-image:hover {
  transform: scale(1.02);
}

.download-section {
  position: sticky;
  bottom: 20px;
  margin-top: 30px;
  z-index: 10;
}

.download-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.download-info {
  flex: 1;
}

.download-title {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 4px;
}

.download-desc {
  font-size: 14px;
  color: #606266;
}

.download-btn {
  min-width: 140px;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
  padding: 0 25px;
  transition: all 0.3s ease;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.vip-btn {
  background: linear-gradient(135deg, #f5c63c 0%, #e6a23c 100%);
  border-color: #e6a23c;
}

.vip-btn:hover {
  background: linear-gradient(135deg, #f6cd52 0%, #e9ab47 100%);
  border-color: #e9ab47;
  box-shadow: 0 4px 12px rgba(230, 162, 60, 0.3);
}

/* 弹窗样式优化 */
.custom-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-content {
  padding: 20px;
}

.dialog-header {
  margin-bottom: 24px;
}

.download-alert {
  margin-bottom: 16px;
}





.vip-reminder {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background: #fdf6ec;
  border-radius: 12px;
  margin-bottom: 24px;
}

.warning-icon {
  font-size: 48px;
  color: #e6a23c;
}

.reminder-text h3 {
  color: #e6a23c;
  margin: 0 0 8px 0;
  font-size: 18px;
}

.reminder-text p {
  color: #606266;
  margin: 0;
  font-size: 14px;
}

.upgrade-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f56c6c 0%, #e6a23c 100%);
  border-color: #f56c6c;
  transition: all 0.3s ease;
}

.upgrade-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
  background: linear-gradient(135deg, #f78989 0%, #e9ab47 100%);
  border-color: #f78989;
}

.parse-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  border-color: #67c23a;
  transition: all 0.3s ease;
}

.parse-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
  background: linear-gradient(135deg, #85ce61 0%, #95d475 100%);
  border-color: #85ce61;
}



/* 移动端适配 */
@media (max-width: 768px) {
  .detail-card {
    padding: 20px;
  }

  .title {
    font-size: 20px;
  }

  .main-image {
    height: 250px;
  }

  .content-image {
    height: 200px;
  }

  .download-card {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .download-btn {
    width: 100%;
  }

  .download-options-grid {
    grid-template-columns: 1fr;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .password-grid {
    grid-template-columns: 1fr;
  }

  .vip-reminder {
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }
}


.site-disclaimer {
  margin-top: 40px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #409EFF;
}

.site-disclaimer h3 {
  color: #303133;
  margin-bottom: 16px;
  font-size: 18px;
}

.site-disclaimer p {
  color: #606266;
  line-height: 1.6;
  margin-bottom: 12px;
  font-size: 14px;
}

.site-disclaimer p:last-child {
  margin-bottom: 0;
}


/* 紧凑的下载统计信息样式 */
.download-stats-compact {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.stat-card {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 32px;
  height: 32px;
  background: #e6f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.stat-icon i {
  color: #409eff;
  font-size: 16px;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  margin-bottom: 2px;
}

.stat-value.unlimited {
  color: #67c23a;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  line-height: 1;
}

.progress-section {
  background: white;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.progress-text {
  color: #409eff;
  font-weight: 600;
}

.download-progress {
  margin: 0;
}

/* 紧凑的下载提示 */
.download-tips-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #909399;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  border-left: 3px solid #409eff;
}

.download-tips-compact i {
  color: #409eff;
  font-size: 16px;
}

/* 紧凑的下载选项网格 */
.download-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.download-option-compact {
  height: 40px;
  border-radius: 6px;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.download-option-compact:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.option-text {
  flex: 1;
  text-align: center;
}

.option-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #409eff;
  color: white;
  padding: 1px 6px;
  font-size: 10px;
  border-radius: 0 6px 0 6px;
  line-height: 1;
}

/* 紧凑的密码提示 */
.password-tips-compact {
  background: #fdf6ec;
  border-radius: 8px;
  padding: 16px;
  border-left: 3px solid #e6a23c;
}

.password-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #e6a23c;
  font-size: 16px;
}

.password-header i {
  font-size: 18px;
}

.password-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.password-item-compact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.password-label {
  font-size: 12px;
  color: #909399;
  font-weight: 500;
}

.password-value-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 4px;
  padding: 6px 8px;
  border: 1px solid #e4e7ed;
}

.password-value {
  flex: 1;
  font-family: 'Courier New', monospace;
  color: #e6a23c;
  font-weight: 600;
  font-size: 13px;
}

.copy-btn-compact {
  color: #409eff;
  padding: 2px;
  margin-left: 4px;
}

.copy-btn-compact:hover {
  color: #66b1ff;
}

.password-note-compact {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #909399;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
}

.password-note-compact i {
  color: #e6a23c;
  font-size: 14px;
}


</style>
